// extracted by mini-css-extract-plugin
export var dropdownIcon = "_n3-6";
export var imgContainer = "_n3-3";
export var menuIcon = "_n3-5";
export var pillWrapper = "_n3-2";
export var pillsContainer = "_n3-1";
export var subscriptionCard = "_n3-0";
export var subscriptionLogo = "_n3-4";